module.exports = __webpack_public_path__ + "media/img/noimage-c58f74070d06ecea8c89c87964325025.jpg";